{
  "metadata": {
    "id": "flexoki-dark",
    "name": "Flexoki",
    "description": "Портировано из темы «Flexoki» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "flexoki.json",
      "project": "kepano",
      "url": "https://github.com/kepano/flexoki",
      "upstreamFile": "packages/ui/src/theme/themes/flexoki.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.474,
      "paletteMaxS": 0.51,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.3,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 24.5,
      "syntaxVsTextMinDeltaE": 8.6,
      "chartsMinDeltaE": 25.2,
      "textSeparationDeltaE": 20.7,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "string",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#DA702C",
      "hover": "#de8145",
      "active": "#e18d56",
      "foreground": "#000000",
      "muted": "#da702c80",
      "emphasis": "#DA702C"
    },
    "surface": {
      "background": "#100F0F",
      "foreground": "#CECDC3",
      "muted": "#262524",
      "mutedForeground": "#96958f",
      "elevated": "#2f2e2c",
      "elevatedForeground": "#CECDC3",
      "raised": "#4a4846",
      "raisedForeground": "#CECDC3",
      "overlay": "#100f0fcc",
      "subtle": "#1d1c1b"
    },
    "interactive": {
      "border": "#4b4a47",
      "borderHover": "#454441",
      "borderFocus": "#DA702C",
      "selection": "#cecdc329",
      "selectionForeground": "#CECDC3",
      "focus": "#da702c59",
      "focusRing": "#da702c61",
      "cursor": "#cecdc3",
      "hover": "#cecdc31c",
      "active": "#cecdc329"
    },
    "status": {
      "error": "#d25145",
      "errorForeground": "#000000",
      "errorBackground": "#d2514524",
      "errorBorder": "#d2514573",
      "warning": "#DA702C",
      "warningForeground": "#000000",
      "warningBackground": "#da702c24",
      "warningBorder": "#da702c73",
      "success": "#879A39",
      "successForeground": "#000000",
      "successBackground": "#879a3924",
      "successBorder": "#879a3973",
      "info": "#3AA99F",
      "infoForeground": "#000000",
      "infoBackground": "#3aa99f24",
      "infoBorder": "#3aa99f73"
    },
    "pr": {
      "open": "#879A39",
      "draft": "#9a9994",
      "blocked": "#DA702C",
      "merged": "#8B7EC8",
      "closed": "#d25145"
    },
    "syntax": {
      "base": {
        "background": "#32312f",
        "foreground": "#CECDC3",
        "comment": "#9a9994",
        "keyword": "#8ea13c",
        "string": "#3AA99F",
        "number": "#9b90d0",
        "function": "#3AA99F",
        "variable": "#699ecb",
        "type": "#D0A215",
        "operator": "#d0cec5"
      },
      "tokens": {
        "commentDoc": "#9a9994",
        "stringEscape": "#d0cec5",
        "keywordImport": "#8ea13c",
        "storageModifier": "#8ea13c",
        "functionCall": "#3AA99F",
        "method": "#3AA99F",
        "variableProperty": "#3AA99F",
        "variableOther": "#699ecb",
        "variableGlobal": "#9b90d0",
        "variableLocal": "#d0cec5",
        "parameter": "#699ecb",
        "constant": "#9b90d0",
        "class": "#D0A215",
        "className": "#D0A215",
        "interface": "#D0A215",
        "struct": "#D0A215",
        "enum": "#D0A215",
        "typeParameter": "#D0A215",
        "namespace": "#D0A215",
        "module": "#8ea13c",
        "tag": "#8ea13c",
        "jsxTag": "#8ea13c",
        "tagAttribute": "#3AA99F",
        "tagAttributeValue": "#3AA99F",
        "boolean": "#9b90d0",
        "decorator": "#8ea13c",
        "label": "#3AA99F",
        "regexp": "#3AA99F"
      }
    },
    "charts": {
      "series": [
        "#DA702C",
        "#3AA99F",
        "#879A39",
        "#daaa2c",
        "#d25145"
      ]
    },
    "chat": {
      "background": "#100F0F",
      "userMessage": "#CECDC3",
      "userMessageBackground": "#2f2e2c",
      "assistantMessage": "#CECDC3",
      "assistantMessageBackground": "#262524",
      "timestamp": "#9a9994",
      "divider": "#4b4a47",
      "typing": "#9a9994"
    },
    "loading": {
      "spinner": "#DA702C",
      "spinnerTrack": "#262524",
      "skeleton": "#262524",
      "shimmer": "#3b3a38"
    },
    "tools": {
      "background": "#262524",
      "border": "#4b4a47",
      "headerHover": "#3a3936",
      "icon": "#DA702C",
      "title": "#CECDC3",
      "description": "#9a9994",
      "edit": {
        "added": "#879A39",
        "addedBackground": "#879a3924",
        "removed": "#d25145",
        "removedBackground": "#d2514524",
        "modified": "#3AA99F",
        "modifiedBackground": "#3aa99f24",
        "lineNumber": "#9a9994"
      }
    },
    "markdown": {
      "heading1": "#CECDC3",
      "heading2": "#CECDC3",
      "heading3": "#CECDC3",
      "heading4": "#CECDC3",
      "link": "#DA702C",
      "linkHover": "#de8145",
      "inlineCode": "#3AA99F",
      "inlineCodeBackground": "#262524",
      "blockquote": "#9a9994",
      "blockquoteBorder": "#4b4a47",
      "listMarker": "#da702cbf",
      "bold": "#CECDC3",
      "italic": "#cecdc3e6",
      "strikethrough": "#9a9994",
      "hr": "#4b4a47"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#cf8b92",
        "foreground": "#000000",
        "contrast": 7.76
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c06444",
        "foreground": "#000000",
        "contrast": 5.15
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#b99853",
        "foreground": "#000000",
        "contrast": 7.68
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c6c857",
        "foreground": "#000000",
        "contrast": 11.8
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b7d492",
        "foreground": "#000000",
        "contrast": 12.85
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#53c551",
        "foreground": "#000000",
        "contrast": 9.47
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#55c584",
        "foreground": "#000000",
        "contrast": 9.71
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#8ddac0",
        "foreground": "#000000",
        "contrast": 12.92
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#52b6c4",
        "foreground": "#000000",
        "contrast": 8.85
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4f8bb6",
        "foreground": "#000000",
        "contrast": 5.7
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#3f67bb",
        "foreground": "#ffffff",
        "contrast": 5.43
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#4040b8",
        "foreground": "#ffffff",
        "contrast": 7.94
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#ba85d4",
        "foreground": "#000000",
        "contrast": 7.39
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#ab47be",
        "foreground": "#ffffff",
        "contrast": 4.8
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bf4689",
        "foreground": "#ffffff",
        "contrast": 4.72
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#be455c",
        "foreground": "#ffffff",
        "contrast": 5.01
      }
    ]
  }
}
